/* import shop from '../api/shop'
 */
import dbConnector from '../api/dbConnector';
import {profileDB} from '../api/dbConnector'
import * as types from '../mutation-types';
import Vue from 'vue'

const path = '/home/nadin-katrin/IdeaProjects/00-laravel-vue/frontend/src/store/modules/users.js';
// initial state
const state = {
  all: [],
  userById: {},
  loggedIn: false,
  active: {},
  edit: {},
  infoText: {
    coach: [],
    athlete: [],
    instructor: [],
    directorate: [],
  },
  directorate: [],
  coachAthleteMapping: [],
  trophyList: []
};

// getters
const getters = {
  allUsers: state => state.all,
  activeUser: state => state.active,
  athletes: state => state.all.filter(user => user.status.indexOf('Athlete') >= 0),
  coaches: state => state.all.filter(user => user.status.indexOf('Coach') >= 0),
  instructors: state => state.all.filter(user => user.status.indexOf('Instructor') >= 0),
  trophyList: state => state.trophyList,
  userById() {
    const userObj = {};
    state.all.forEach(user => {
      userObj[user.id] = user;
    });
    return userObj;
  },
  directorates() {
    const userObj = [];
    state.directorate.forEach(directorate => {
      if(state.userById[directorate.ref_user_id].status.indexOf('Directorate')!==-1)
        userObj.push({...directorate, ...state.userById[directorate.ref_user_id]})
    })
    return userObj;
  },
  coachInfoTextById() {
    const userObj = {};
    state.infoText.coach.forEach(coach => {
      if(state.userById[coach.ref_user_id].status.indexOf('Coach')!==-1 )
         userObj[coach.ref_user_id] = coach;
    });
    return userObj;
  },
  instructorInfoTextById() {
    const userObj = {};
    state.infoText.instructor.forEach(instructor => {
      if(state.userById[instructor.ref_user_id].status.indexOf('Instructor')!==-1)
        userObj[instructor.ref_user_id] = instructor;
    });
    return userObj;
  },
  athleteInfoTextById() {
    const userObj = {};
    state.infoText.athlete.forEach(athlete => {
  /*    console.log('----\n',state.userById[athlete.ref_user_id], state.userById[athlete.ref_user_id].status.findIndex(state => state === 'Athlete'))
      if(state.userById[athlete.ref_user_id] && state.userById[athlete.ref_user_id].status.findIndex(state => state === 'Athlete')!==-1)*/
          userObj[athlete.ref_user_id] = athlete;
    });
    return userObj;
  },
  coachAthleteMapping() {
    const userObj = {};
    state.coachAthleteMapping.forEach(coach => {
      if (!userObj[coach.coach_id]) userObj[coach.coach_id] = {}
      userObj[coach.coach_id][coach.athlete_id] = getters.userById()[coach.athlete_id];
    });
    return userObj;
  },
  athleteCoachMapping() {
    const userObj = {};
    state.coachAthleteMapping.forEach(coach => {
      if (!userObj[coach.athlete_id]) userObj[coach.athlete_id] = {}
      userObj[coach.athlete_id][coach.coach_id] = getters.userById()[coach.coach_id];
    });
    return userObj;
  },
  trophyByUser() {
    const userObj = {};
    state.trophyList.forEach(trophy => {
      if (!userObj[trophy.user_id]) userObj[trophy.user_id] = []
      userObj[trophy.user_id].push(trophy)
    });
    return userObj;
  }
};

// actions
const actions = {
  getAllUsers({commit}, cb) {
    dbConnector.getUsers(users => {
      commit(types.RECEIVE_USERS, {users});
      if (cb) cb();
    });
  },
  getAthleteInfoText({commit}, cb) {
    profileDB.getAthleteInfoText(text => {
      commit(types.GET_ATHLETE_INFO_TEXT, {text})
      if (cb) cb()
    })
  },
  getCoachInfoText({commit}, cb) {
    profileDB.getCoachInfoText(text => {
      commit(types.GET_COACH_INFO_TEXT, {text})
      if (cb) cb()
    })
  },
  getDirectorate({commit}, cb) {
    profileDB.getDirectorate(directorate => {
      commit(types.GET_DIRECTORATE, {directorate})
      if (cb) cb()
    })
  },
  getCoachAthleteMapping({commit}, cb) {
    profileDB.getCoachAthleteMapping(mapping => {
      commit(types.GET_COACH_ATHLETE_MAPPING, {mapping})
      if (cb) cb()
    })
  },
  getTrophyList({commit}, cb) {
    profileDB.getTrophyList(trophyList => {
      commit(types.GET_TROPHY_LIST, {trophyList})
      if (cb) cb()
    })
  },
  logIn({commit}, {userName, cb}) {
    if (state.all.length === 0) {
      dbConnector.getUsers(users => {
        commit(types.IS_LOGGED_IN, {userName, users, cb});
      });
    } else {
      // console.log(state.all)
      commit(types.IS_LOGGED_IN, {userName, users: state.all, cb});
    }
  },
  showLoginDialog({commit}) {
    commit(types.SHOW_LOGIN_DIALOG);
  },
  toggleLoginDialog({commit}) {
    commit(types.TPGGLE_LOGIN_DIALOG);
  },
  updatePoints({commit}, {user_id, points}) {
    commit(types.UPDATE_POINTS, {user_id, points});
  },
};

// mutations
const mutations = {
  [types.RECEIVE_USERS](state, {users}) {
    state.all = users;
    const userObj = {};
    users.forEach(user => {
      userObj[user.id] = user;
    });
    // console.log(userObj)
    state.userById = userObj;
  },
  [types.SHOW_LOGIN_DIALOG](state) {
    state.loggedIn = true;
  },
  [types.TPGGLE_LOGIN_DIALOG](state) {
    state.loggedIn = !state.loggedIn;
  },
  [types.IS_LOGGED_IN](state, {userName, users, cb}) {
    const activeUser = users.find((user) => user.userName === userName);
    cb(activeUser)

    if (!activeUser) console.error(`Either users are not in store yet, or no initial user was created! ${path}`);
    else if (activeUser) {
      state.active = activeUser;
      state.active.updated_at = Vue.helper.getTimeStamp();
      state.edit = activeUser;
      state.edit.imgFile = '';
      state.all = users;
      cb(activeUser);
    }  // console.log('user does not exist yet');
  },
  [types.UPDATE_POINTS](state, {user_id, points}) {
    getters.userById()[user_id].points = parseInt(getters.userById()[user_id].points, 10) + points;
    dbConnector.putUser(getters.userById()[user_id]);
  },
  [types.GET_ATHLETE_INFO_TEXT](state, {text}) {
    state.infoText.athlete = text

  },
  [types.GET_COACH_INFO_TEXT](state, {text}) {
    state.infoText.coach = text
    state.infoText.instructor = text
  },
  [types.GET_DIRECTORATE](state, {directorate}) {
    state.directorate = directorate
  },
  [types.GET_COACH_ATHLETE_MAPPING](state, {mapping}) {
    state.coachAthleteMapping = mapping
  },
  [types.GET_TROPHY_LIST](state, {trophyList}) {
    state.trophyList = trophyList
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
